var _a, _b, _c, _d, _e, _f, _g, _h;
import { __decorate, __metadata } from "tslib";
import { Mutation, VuexModule, Module } from 'vuex-module-decorators';
import { MutationsGeneral } from '@/store/enums/pscm/migo/generalEnum';
import * as bootstrap from 'bootstrap';
function setErrorCode(params) {
    let code = String(params.statusCode);
    let errorDesc;
    let message = 'Please, contact your technical team';
    switch (code) {
        case '400':
            errorDesc = params.result.message;
            break;
        case '408':
            errorDesc = 'Error ' + code + ' : Request Timeout';
            break;
        case '500':
            errorDesc = 'Error ' + code + ' : Internal Server Error';
            break;
        case '502':
            errorDesc = 'Error ' + code + ' : Bad Gateway';
            break;
        case '504':
            errorDesc = 'Error ' + code + ' : Gateway Timeout';
            break;
        default:
            if (code == 'undefined')
                code = null;
            message = null;
            errorDesc = params.message;
            break;
    }
    return { code, errorDesc, message };
}
let GeneralMigo = class GeneralMigo extends VuexModule {
    constructor() {
        super(...arguments);
        this.isAllowSubmitPost = true;
        this.showErrorHandlerMigo = {
            code: null,
            errorDesc: null,
            message: null
        };
        this.showConfirmationMigo = {
            id: null,
            text: null,
            buttonLeftText: null,
            buttonRightText: null,
            flag: null
        };
        this.showSuccessMigo = {
            text: null,
            flag: null
        };
        this.showInformationMigo = {
            text: null,
            flag: null
        };
        this.loading = {
            show: true,
            type: '',
            message: null
        };
        this.pageNow = '';
    }
    get getAllowSubmitPostMigo() {
        return this.isAllowSubmitPost;
    }
    get getMigoLoading() {
        return this.loading;
    }
    get getConfirmationMigo() {
        return this.showConfirmationMigo;
    }
    get getErrorHandlerMigo() {
        return this.showErrorHandlerMigo;
    }
    get getSuccessMigo() {
        return this.showSuccessMigo;
    }
    get getInformationMigo() {
        return this.showInformationMigo;
    }
    get getPageNowGoodsMigo() {
        return this.pageNow;
    }
    [_a = MutationsGeneral.SET_PAGE_GOODS_MIGO](data) {
        this.pageNow = data;
    }
    [_b = MutationsGeneral.SET_ALLOW_SUBMIT](data) {
        this.isAllowSubmitPost = data;
    }
    [_c = MutationsGeneral.RESET_ALLOW_SUBMIT]() {
        this.isAllowSubmitPost = true;
    }
    [_d = MutationsGeneral.SET_LOADING](data) {
        this.loading = data;
    }
    [_e = MutationsGeneral.SET_CONFIRMATION](data) {
        this.showConfirmationMigo = data;
        if (!data.id || data.id === '' || data.id === null) {
            const myModal = new bootstrap.Modal(document.getElementById('modal_confirmation_migo'));
            myModal.show();
        }
        else {
            const idModal = String(data.id);
            const myModal = new bootstrap.Modal(document.getElementById(idModal));
            myModal.show();
        }
    }
    [_f = MutationsGeneral.SET_ERROR](data) {
        this.showErrorHandlerMigo = setErrorCode(data);
        const myModal = new bootstrap.Modal(document.getElementById('modal_error_handler'));
        myModal.show();
    }
    [_g = MutationsGeneral.SET_SUCCESS](data) {
        this.showSuccessMigo = data;
        if (!data.id || data.id === '' || data.id === null) {
            const myModal = new bootstrap.Modal(document.getElementById('modal_success_migo'));
            myModal.show();
        }
        else {
            const myModal = new bootstrap.Modal(document.getElementById(data.id));
            myModal.show();
        }
    }
    [_h = MutationsGeneral.SET_INFORMATION](data) {
        this.showInformationMigo = data;
        const myModal = new bootstrap.Modal(document.getElementById('modal_information_migo'));
        myModal.show();
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], GeneralMigo.prototype, _a, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], GeneralMigo.prototype, _b, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], GeneralMigo.prototype, _c, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], GeneralMigo.prototype, _d, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], GeneralMigo.prototype, _e, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], GeneralMigo.prototype, _f, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], GeneralMigo.prototype, _g, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], GeneralMigo.prototype, _h, null);
GeneralMigo = __decorate([
    Module
], GeneralMigo);
export default GeneralMigo;
